
import { QueryClient } from '@tanstack/react-query';

/**
 * Creates a configured instance of QueryClient
 */
export const createCustomQueryClient = (config = {}) => {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60 * 5, // 5 minutes
        retry: 1,
      },
    },
    ...config,
  });
};
